import { createSlice, PayloadAction } from "@reduxjs/toolkit";

import { IDEA_LIBRARY } from "@src/store/slices/experienceBuilder/ideas/data";
import type {
  Idea,
  IdeaCategoryFilter,
  IIdeasState,
} from "@src/store/slices/experienceBuilder/ideas/types";

const initialState: IIdeasState = {
  ideas: IDEA_LIBRARY,
  libraryOpen: false,
  query: "",
  category: "all",
};

export const ideasSlice = createSlice({
  name: "experienceBuilderIdeas",
  initialState,
  reducers: {
    // Open the full-panel library. Starts from a clean "all" view each time.
    // Private: entry points go through the `openLibrary` thunk, which reveals
    // the chat panel this renders in. Tracking listens on this action.
    _openLibrary: (state) => {
      state.libraryOpen = true;
      state.query = initialState.query;
      state.category = initialState.category;
    },
    closeLibrary: (state) => {
      state.libraryOpen = false;
    },
    setQuery: (state, action: PayloadAction<string>) => {
      state.query = action.payload;
    },
    setCategory: (state, action: PayloadAction<IdeaCategoryFilter>) => {
      state.category = action.payload;
    },
    // Replace the catalog wholesale — the seam for loading ideas from a remote
    // API later (a thunk fetches, then dispatches this). Unused while the
    // catalog is a static seed.
    setIdeas: (state, action: PayloadAction<Idea[]>) => {
      state.ideas = action.payload;
    },
  },
  selectors: {
    getIdeas: (state) => state.ideas,
    isLibraryOpen: (state) => state.libraryOpen,
    getQuery: (state) => state.query,
    getCategory: (state) => state.category,
  },
});
